import { render, staticRenderFns } from "./TemplateContentEditor.vue?vue&type=template&id=13c16899&lang=pug&"
import script from "./TemplateContentEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateContentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports